var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAdminSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.7637 26.25L16.8887 18.375C16.2637 18.875 15.5449 19.2708 14.7324 19.5625C13.9199 19.8542 13.0553 20 12.1387 20C9.86784 20 7.94617 19.2133 6.37367 17.64C4.80117 16.0667 4.01451 14.145 4.01367 11.875C4.01284 9.605 4.79951 7.68333 6.37367 6.11C7.94784 4.53667 9.86951 3.75 12.1387 3.75C14.4078 3.75 16.3299 4.53667 17.9049 6.11C19.4799 7.68333 20.2662 9.605 20.2637 11.875C20.2637 12.7917 20.1178 13.6562 19.8262 14.4688C19.5345 15.2812 19.1387 16 18.6387 16.625L26.5137 24.5L24.7637 26.25ZM12.1387 17.5C13.7012 17.5 15.0295 16.9533 16.1237 15.86C17.2178 14.7667 17.7645 13.4383 17.7637 11.875C17.7628 10.3117 17.2162 8.98375 16.1237 7.89125C15.0312 6.79875 13.7028 6.25167 12.1387 6.25C10.5745 6.24833 9.24659 6.79542 8.15492 7.89125C7.06326 8.98708 6.51617 10.315 6.51367 11.875C6.51117 13.435 7.05826 14.7633 8.15492 15.86C9.25159 16.9567 10.5795 17.5033 12.1387 17.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdminSearch);
export default __webpack_public_path__ + "static/media/adminSearch.66d09eb4f5b6d70c5e4527fb028d07cf.svg";
export { ForwardRef as ReactComponent };